import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

import { toBase64, getFileExtension } from '../../../../utils/util';

import { requestCreatePost, requestUpdatePost } from '../../../../api/market-buzz/market-buzz.actions';

import MarketBuzzCreatePost from '../../../../components/screens/market/market-buzz/market-buzz-create-post/MarketBuzzCreatePost';

const MarketBuzzCreatePostContainer = () => {
  const { product, post } = useSelector(({ marketBuzz }) => marketBuzz);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!location) return;

    if (location.pathname.includes('edit') && !post) {
      navigate('/market/market-buzz');
    }
  }, [location, navigate, post]);

  const mapImages = async (files) => {
    const mappedFiles = [];
    const linkedMediaExternalReferences = [];

    for (const file of files) {
      if (typeof file === 'string') {
        linkedMediaExternalReferences.push(file);
        continue;
      }

      mappedFiles.push({
        base64String: await toBase64(file),
        documentExtension: getFileExtension(file.name),
      });
    }

    return [mappedFiles, linkedMediaExternalReferences];
  };

  const createPost = async (text, images, poll) => {
    const [photos] = await mapImages(images);
    const post = {
      question: poll?.question,
      options: poll?.options?.map((option) => option.value),
      productExternalReference: product?.productExternalReference,
      photos,
      text,
    };

    dispatch(requestCreatePost({ post, onSuccess: () => navigate('/market/market-buzz') }));
  };

  const updatePost = async (text, images, poll) => {
    const [photos, linkedMediaExternalReferences] = await mapImages(images);
    const postToUpdate = {
      postExternalReference: post?.externalReference,
      question: poll?.question,
      options: poll?.options?.map((option) => option.value),
      productExternalReference: post?.productExternalReference,
      photos,
      linkedMediaExternalReferences,
      text,
    };

    dispatch(requestUpdatePost({ post: postToUpdate, onSuccess: () => navigate('/market/market-buzz') }));
  };

  return <MarketBuzzCreatePost post={post} product={product} createPost={createPost} updatePost={updatePost} />;
};

export default MarketBuzzCreatePostContainer;
